import { Controller } from '@hotwired/stimulus'

const DISMISS_KEY = 'ebazzari-pwa-install-dismissed-at'
const DISMISS_FOR_MS = 14 * 24 * 60 * 60 * 1000

export default class extends Controller {
  static targets = ['button']

  connect() {
    this.deferredPrompt = null
    this.handleBeforeInstallPrompt = this.handleBeforeInstallPrompt.bind(this)
    this.handleAppInstalled = this.handleAppInstalled.bind(this)

    window.addEventListener('beforeinstallprompt', this.handleBeforeInstallPrompt)
    window.addEventListener('appinstalled', this.handleAppInstalled)
  }

  disconnect() {
    window.removeEventListener('beforeinstallprompt', this.handleBeforeInstallPrompt)
    window.removeEventListener('appinstalled', this.handleAppInstalled)
  }

  async install() {
    if (!this.deferredPrompt) return

    this.buttonTarget.disabled = true
    await this.deferredPrompt.prompt()
    await this.deferredPrompt.userChoice
    this.deferredPrompt = null
    this.element.classList.add('hidden')
  }

  dismiss() {
    window.localStorage.setItem(DISMISS_KEY, Date.now().toString())
    this.element.classList.add('hidden')
  }

  handleBeforeInstallPrompt(event) {
    event.preventDefault()
    if (this.recentlyDismissed() || this.runningStandalone()) return

    this.deferredPrompt = event
    this.buttonTarget.disabled = false
    this.element.classList.remove('hidden')
  }

  handleAppInstalled() {
    this.deferredPrompt = null
    this.element.classList.add('hidden')
    window.localStorage.removeItem(DISMISS_KEY)
  }

  recentlyDismissed() {
    const dismissedAt = Number(window.localStorage.getItem(DISMISS_KEY))
    return Number.isFinite(dismissedAt) && Date.now() - dismissedAt < DISMISS_FOR_MS
  }

  runningStandalone() {
    return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true
  }
}
